import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { ANIMAL_GROUPS } from '../animal-group.mock';
import { ANIMALS } from '../animal.mock';

@Injectable()
export class AnimalEntityServiceMock {
  entities$ = of(ANIMALS);

  getByKey() {
    return of(ANIMALS[1]);
  }

  getAll() {
    return of(ANIMALS);
  }
}

@Injectable()
export class AnimalGroupEntityServiceMock {
  entities$ = of(ANIMAL_GROUPS);

  getAll() {
    return of(ANIMAL_GROUPS);
  }
}
